import { SetAgentControlPanelType } from "../action-types/agentpanel.action.types";

export const SetAgentControlPanel = (message: any) => {
  return {
    type: SetAgentControlPanelType.SET_AGENT_CONTROL_PANEL,
    payload: message,
  };
};
